// extracted by mini-css-extract-plugin
export default {"page":"CodePage_page__C+g6H","card":"CodePage_card__2g183","header":"CodePage_header__N2XBL","badge":"CodePage_badge__d269v","submitBtn":"CodePage_submitBtn__KDENv"};